import { render } from "./ContactTypeDetails.vue?vue&type=template&id=436d9fe4"
import script from "./ContactTypeDetails.vue?vue&type=script&lang=js"
export * from "./ContactTypeDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__